import { c as _c } from "react/compiler-runtime";
import limechainLogo from "@/assets/jpeg/limechain.jpeg";
import mentormateLogo from "@/assets/jpeg/mentormate.jpeg";
import sitegroundLogo from "@/assets/png/siteground.png";
import { cn } from "@/utils/helpers";
import { Building2 } from "lucide-react";
import Image from "next/image";
type CompanyLogoSize = "sm" | "lg";
interface CompanyLogoProps {
  company: string;
  size?: CompanyLogoSize;
}
const getLogoConfig = (company: string) => {
  const companyLower = company.toLowerCase();
  if (companyLower.includes("siteground")) {
    return {
      src: sitegroundLogo,
      alt: "SiteGround Logo"
    };
  }
  if (companyLower.includes("limechain")) {
    return {
      src: limechainLogo,
      alt: "LimeChain Logo"
    };
  }
  if (companyLower.includes("mentormate")) {
    return {
      src: mentormateLogo,
      alt: "MentorMate Logo"
    };
  }
  return null;
};
const getLogoSizeConfig = (size: CompanyLogoSize) => {
  return size === "lg" ? {
    containerSize: "w-16 h-16",
    logoSize: "4rem"
  } : {
    containerSize: "w-12 h-12",
    logoSize: "3rem"
  };
};
export const CompanyLogo = t0 => {
  const $ = _c(9);
  const {
    company,
    size: t1
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  let t2;
  let t3;
  if ($[0] !== company || $[1] !== size) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        containerSize,
        logoSize
      } = getLogoSizeConfig(size);
      let t4;
      if ($[4] !== company) {
        t4 = getLogoConfig(company);
        $[4] = company;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      const logoConfig = t4;
      if (logoConfig) {
        t3 = <div className={cn("relative", containerSize, "rounded-xl overflow-hidden shrink-0")}><Image src={logoConfig.src} alt={logoConfig.alt} fill={true} sizes={logoSize} className="object-cover" /></div>;
        break bb0;
      }
      t2 = cn(containerSize, "rounded-xl bg-white/10 flex items-center justify-center border border-white/20");
    }
    $[0] = company;
    $[1] = size;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Building2 className="w-6 h-6" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2) {
    t5 = <div className={t2}>{t4}</div>;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};